import Radio from 'antd/es/radio';
import classNames from 'classnames';
import { ReactNode } from 'react';
import { InfoCircleIcon } from '../icons';
import style from './RadioButton.module.css';
import { TooltipNew } from './TooltipNew.tsx';

export interface RadioButtonItem<T = string> {
  label: ReactNode | string;
  disabled?: boolean;
  value: T;
  description?: string;
}

export interface RadioButtonProps<T> {
  items: RadioButtonItem<T>[];
  value: T;
  onChange: (value: T) => void;
  className?: string;
  buttonClassName?: string;
  error?: string;
}

export const RadioButton = <T,>({
  items,
  value,
  onChange,
  className,
  buttonClassName,
  error,
}: RadioButtonProps<T>) => {
  return (
    <div className="flex flex-col gap-2">
      <Radio.Group
        style={{ width: '100%' }}
        onChange={e => onChange(e.target.value)}
        value={value}
        className={className}
      >
        {items.map(({ label, value, disabled, description }, index) => (
          <Radio
            key={`${value}_${index}`}
            style={{ width: '100%' }}
            disabled={disabled}
            value={value}
            className={classNames(buttonClassName, style.checkboxUp)}
          >
            <span className="flex gap-1 items-center relative">
              <span>{label}</span>
              {description && (
                <TooltipNew text={description}>
                  <img alt="info" src={InfoCircleIcon} className="min-w-4 min-h-4 h-4 w-4" />
                </TooltipNew>
              )}
            </span>
          </Radio>
        ))}
      </Radio.Group>
      {error && <span className="text-error-red text-sm">{error}</span>}
    </div>
  );
};
